import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { AppStateFacade } from '@app-state';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var QueueDefinitionService = /** @class */ (function (_super) {
    tslib_1.__extends(QueueDefinitionService, _super);
    function QueueDefinitionService(http, _a) {
        var authConfig = _a.authConfig;
        var _this = _super.call(this, http, MapperService.queueMap) || this;
        _this.suggest = function (searchTerm, fetchSize, skip) {
            if (searchTerm === void 0) { searchTerm = ''; }
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = {
                select: ['Id', 'Name'],
                orderBy: ['Name'],
                top: fetchSize,
                skip: skip,
                filter: {
                    Name: {
                        startswith: searchTerm,
                    },
                },
            };
            return _this._suggest(queryOptions);
        };
        _this.queueTriggerSuggest = function (triggerId, searchTerm, fetchSize, skip) {
            if (searchTerm === void 0) { searchTerm = ''; }
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = {
                select: ['Id', 'Name'],
                orderBy: ['Name'],
                top: fetchSize,
                skip: skip,
                filter: {
                    and: [
                        {
                            Name: {
                                startswith: searchTerm,
                            },
                        },
                        {
                            or: [
                                {
                                    'ProcessScheduleId': null,
                                },
                                {
                                    'ProcessScheduleId': isNaN(triggerId) ? -1 : triggerId,
                                },
                            ],
                        }
                    ],
                },
            };
            return _this._suggest(queryOptions);
        };
        _this._endpoint = authConfig.odataBaseUrl + "/QueueDefinitions";
        return _this;
    }
    QueueDefinitionService.prototype.getQueueNameById = function (queueDefinitionId) {
        return this.getInstance(queueDefinitionId)
            .pipe(map(function (res) { return res.name; }));
    };
    QueueDefinitionService.prototype.getQueueNameAndSlaById = function (queueDefinitionId) {
        return this.getInstance(queueDefinitionId)
            .pipe(map(function (res) { return ({ name: res.name, slaMinutes: res.slaMinutes }); }));
    };
    QueueDefinitionService.prototype.getReportsUrl = function (queueDefinitionId, queryOptions) {
        return this._endpoint + "(" + queueDefinitionId + ")/UiPathODataSvc.Reports" + this.getQueryString(queryOptions);
    };
    QueueDefinitionService.prototype.getDownloadSchemaJsonLink = function (queueDefinitionId, schemaType) {
        return this._endpoint + "(" + queueDefinitionId + ")/UiPathODataSvc.GetJsonSchemaDefinition(jsonSchemaType='" + schemaType + "')";
    };
    QueueDefinitionService.prototype._suggest = function (queryOptions) {
        return this.get(queryOptions, this._endpoint)
            .pipe(map(function (_a) {
            var data = _a.data, total = _a.total;
            return ({
                total: total,
                data: data.map(function (queue) { return ({
                    id: queue.id,
                    text: queue.name,
                }); }),
            });
        }));
    };
    return QueueDefinitionService;
}(ODataService));
export { QueueDefinitionService };
